import React, { useContext, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';
import { useAuth } from './AuthContext';

const AdvertisersContext = React.createContext();

export function useAdvertisers() {
    return useContext(AdvertisersContext);
}

export function AdvertisersProvider({ children }) {
    const [advertisers, setAdvertisers] = useState({
        advertiserList: [],
    });
    const [advertiserMetaData, setAdvertiserMetaData] = useState({
        selectedAdvertiserPlanData: {},
        selectedAdvertiserTeachData: {},
    });

    const [shouldFetchAdvertiserData, setShouldFetchAdvertiserData] = useState(false);
    const [shouldFetchOtherData, setShouldFetchOtherData] = useState(false);
    const [currentAdvertiser, setCurrentAdvertiser] = useState(null);

    const { currentUser } = useAuth();
    const { accessToken, isAuthenticated, accountIsComplete, emailIsVerified } = { ...currentUser };

    const accountIsLoaded = accessToken && isAuthenticated && accountIsComplete && emailIsVerified;

    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: `Bearer ${accessToken}`,
    };

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const fetchData = async () => {
        try {
            const advertiserData = await axios.get(`${baseURL}/getAdvertiser`, { headers });
            const allAdvertisersInAgencyData = await axios.get(`${baseURL}/getAllAdvertisersInAgency`, { headers });
            setCurrentAdvertiser(
                currentAdvertiser === null || currentAdvertiser === undefined || shouldFetchAdvertiserData ? advertiserData.data : currentAdvertiser
            );

            setAdvertisers({
                ...advertisers,
                advertiserList: allAdvertisersInAgencyData.data,
            });
        } catch (error) {
            // Handle error
            console.log('Error fetching advertiser data:', error);
        }
    };

    const fetchOtherData = async () => {
        try {
            const planData = await axios.get(`${baseURL}/getPlan/${currentAdvertiser?.planTypeId}`, {
                headers,
            });
            const teachDavieData = await axios.get(`${baseURL}/GetTeachDavieDataByAdvertiser/${currentAdvertiser?.advertiserId}`, { headers });

            setAdvertiserMetaData({
                ...advertiserMetaData,
                selectedAdvertiserPlanData: planData.data,
                selectedAdvertiserTeachData: teachDavieData.data,
            });
        } catch (error) {
            // Handle error
            console.log('Error fetching advertiser data:', error);
        }
    };

    useEffect(() => {
        if (accountIsLoaded) {
            fetchData();
        }
    }, [accessToken, isAuthenticated, emailIsVerified, accountIsComplete]);

    useEffect(() => {
        if (shouldFetchAdvertiserData === true) {
            fetchData();
            setShouldFetchAdvertiserData(false);
        }
    }, [shouldFetchAdvertiserData]);

    useEffect(() => {
        if (shouldFetchOtherData === true) {
            fetchOtherData();
            setShouldFetchOtherData(false);
        }
    }, [shouldFetchOtherData]);

    useEffect(() => {
        if (accountIsLoaded && currentAdvertiser) {
            fetchOtherData();
        }
    }, [accessToken, isAuthenticated, emailIsVerified, accountIsComplete, currentAdvertiser]);

    console.log(currentAdvertiser, ' current');
    const value = {
        advertisers,
        setAdvertisers,
        setShouldFetchAdvertiserData,
        setShouldFetchOtherData,
        setCurrentAdvertiser,
        currentAdvertiser,
        advertiserMetaData,
    };

    return <AdvertisersContext.Provider value={value}>{children}</AdvertisersContext.Provider>;
}

AdvertisersProvider.propTypes = {
    children: propTypes.node.isRequired,
};
